/**
 * Helper that'll determine which locale value to apply to react-intl, based on
 * the given internal locale value (for instance if we're using da-dk, then we
 * should apply da to react-intl...)
 */
export function getReactIntlLocale(locale: string): string {
    switch (locale) {
        case "da-dk":
            return "da";

        default:
            throw new Error(`getReactIntlLocale(): Unsupported locale"${ locale }".`);
    }
}
